import { render, staticRenderFns } from "./Persion.vue?vue&type=template&id=47eae5e8&"
import script from "./Persion.vue?vue&type=script&lang=js&"
export * from "./Persion.vue?vue&type=script&lang=js&"
import style0 from "./Persion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports